import { useEffect, useRef } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAccount } from '../components/contexts/AccountContextManager';
import ApplyCompanyTheming from '../components/contexts/ApplyCompanyTheming';
import { useCompany } from '../components/contexts/CompanyContextManager';
import NotFoundResult from '../components/results/NotFoundResult';
import ActivateUserAccountPage from '../pages/login/ActivateUserAccountPage';
import ResetPasswordPage from '../pages/login/ResetPasswordPage';
import SignInPage from '../pages/login/SignInPage';
import VerifyEmailUpdatePage from '../pages/login/VerifyEmailUpdatePage';
import { useRuntimeConfig } from '../runtimeConfig';

const LoginRouter = () => {
    const user = useAccount(true);
    const company = useCompany(true);
    const { router } = useRuntimeConfig();

    const isMounted = useRef(false);
    // check if user is already authenticated
    if (user && !isMounted.current) {
        if (router.withAdmin) {
            // redirect to admin
            return <Navigate to="/admin" />;
        }

        // otherwise redirect to homepage
        return <Navigate to="/" />;
    }

    useEffect(() => {
        isMounted.current = true;
    }, []);

    const content = (
        <Routes>
            <Route element={<Navigate to="signIn" />} path="" />
            <Route element={<SignInPage />} path="signIn" />
            <Route element={<ResetPasswordPage />} path="resetPassword" />
            <Route element={<ActivateUserAccountPage />} path="activate" />
            <Route element={<VerifyEmailUpdatePage />} path="verifyEmail" />
            <Route element={<NotFoundResult />} path="*" />
        </Routes>
    );

    if (company) {
        return <ApplyCompanyTheming>{content}</ApplyCompanyTheming>;
    }

    return content;
};

export default LoginRouter;
